import React from 'react';
import { policyContent } from '../../components/Policy/policyContent';

const PrivacyPolicySection = () => {
  const current = policyContent.terms;

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="hidden sm:block px-0 sm:px-0 py-4">
        <h2 className="text-2xl font-semibold text-black">{current.title}</h2>
        <p className="text-black text-sm">{current.subtitle}</p>
      </div>
      
      <p className="px-4 sm:px-0 max-w-2xl font-semibold text-[#6b8f3a] text-sm pb-2 sm:mb-4">
        {current.tagline}
      </p>

      {current.lastUpdated && (
        <p className="px-4 sm:px-0 max-w-2xl text-gray-500 text-xs pb-2 sm:mb-4">
          Last Updated: {current.lastUpdated}
        </p>
      )}

      {/* Content */}
      <div className="py-4 sm:py-0 px-4 sm:px-0 pb-8 max-w-2xl">
        <div className="space-y-6">
          {current.sections.map((section, idx) => (
            <div key={idx}>
              <h3 className="text-lg font-semibold text-black mb-3">{section.title}</h3>
              
              {section.content && (
                <p className="text-black text-base whitespace-pre-line">
                  {section.content}
                </p>
              )}
              
              {section.subsections && section.subsections.length > 0 && (
                <div className="space-y-4">
                  {section.subsections.map((subsection, subIdx) => (
                    <div key={subIdx}>
                      <h4 className="font-bold text-black mb-1">{subsection.subtitle}</h4>
                      <p className="text-black text-base whitespace-pre-line">
                        {subsection.content}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

          {/* Footer Section */}
          <div className="p-4 sm:p-6 border-t border-gray-100 mt-8">
            <p className="text-sm text-black text-center">
              © 2026 Wryven. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicySection;